import { Injectable } from '@angular/core';
import { DataContextService } from '@seahorse/common';

import {
  UiModule,
  UiModuleDefinition,
  UiModuleOverviewConfiguration,
} from '@seahorse/domain';

@Injectable({
  providedIn: 'root',
})
export class UiModuleConfigurationOverviewDataService {
  private readonly _baseUrl = 'customdata/uimodule-configuration/overview';

  constructor(private _dataContextService: DataContextService) {}

  addOverviewConfiguration(
    module: UiModule | UiModuleDefinition,
    config: UiModuleOverviewConfiguration
  ) {
    if (
      Object.prototype.hasOwnProperty.call(module, 'organisationId') &&
      Object.prototype.hasOwnProperty.call(module, 'definitionId')
    ) {
      return this._dataContextService.post<UiModuleOverviewConfiguration>(
        `${this._baseUrl}/${module.id}`,
        config
      );
    }

    return this._dataContextService.post<UiModuleOverviewConfiguration>(
      `${this._baseUrl}/definition/${module.id}`,
      config
    );
  }

  addForSeahorseModule(
    seahorseModuleId: number,
    config: UiModuleOverviewConfiguration
  ) {
    return this._dataContextService.post<UiModuleOverviewConfiguration>(
      `${this._baseUrl}/seahorse/${seahorseModuleId}`,
      config
    );
  }

  updateOverviewConfiguration(config: UiModuleOverviewConfiguration) {
    return this._dataContextService.put<UiModuleOverviewConfiguration>(
      `${this._baseUrl}`,
      config
    );
  }
}
